import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import MomentPropTypes from 'react-moment-proptypes';
import CardSectionHeading from '../CardSectionHeading';
import CardRowKeyVal from '../CardRowKeyVal';
import moment from 'moment-timezone';
import compact from 'lodash/compact';
import get from 'lodash/get';
import map from 'lodash/map';

const propTypes = {
  details: PropTypes.shape({
    address: PropTypes.shape({
      line1: PropTypes.string,
      line2: PropTypes.string,
      city: PropTypes.string,
      region: PropTypes.string,
      postal: PropTypes.string,
    }),
    coverage_start_date: MomentPropTypes.momentString,
    personal_property_amount: PropTypes.string,
    all_peril_deductible: PropTypes.string,
    liability_limit: PropTypes.string,
  }),
};

const defaultProps = {
  details: {},
};

class PolicyDetailsRentersAssurant extends PureComponent {

  regionalConditionalLabels = {
    replacement_cost: 'Replacement cost',
    pet_damage: 'Pet damage',
    water_backup: 'Sewer or drain backup',
    identity_fraud: 'Identity fraud',
    earthquake: 'Earthquake damage',
  };

  get regionalConditionalNodes() {
    return compact(map(this.regionalConditionalLabels, (label, key) => {
      if (get(this.props.details, `${key}.allowed`)) {
        return (
          <CardRowKeyVal
            key={key}
            title={label}
            detail={get(this.props.details, `${key}.caption`)}
          />
        );
      }
    }));
  }

  get coverageStartDate() {
    return moment(this.props.coverage_start_date, 'YYYY-MM-DD').format('MMM DD, YYYY');
  }

  get coverageEndDate() {
    return moment(this.props.coverage_end_date, 'YYYY-MM-DD').format('MMM DD, YYYY');
  }

  render() {
    const { details } = this.props;

    return (
      <div>
        <CardRowKeyVal
          title="Coverage period"
          detail={`From ${this.coverageStartDate} to ${this.coverageEndDate}`}
        />
        <CardSectionHeading>
          Location Details
        </CardSectionHeading>
        <CardRowKeyVal
          title="Address"
          detail={
            <div>
              <span>{details.address.line1}</span>
              <br/>
              {details.address.line2 && [<span key="line2">{details.address.line2}</span>, <br key="line2br" />]}
              <span>{details.address.city}, {details.address.region} {details.address.postal}</span>
            </div>
          }
        />
        <CardRowKeyVal
          title="Start date"
          detail={this.coverageStartDate}
        />
        <CardSectionHeading>
          Policy Selections
        </CardSectionHeading>
        <CardRowKeyVal
          title="Personal property"
          detail={details.personal_property_amount}
        />
        <CardRowKeyVal
          title="Deductible"
          detail={details.all_peril_deductible}
        />
        <CardRowKeyVal
          title="Personal liability"
          detail={details.liability_limit}
        />

        {this.regionalConditionalNodes}
      </div>
    );
  }
}

PolicyDetailsRentersAssurant.propTypes = propTypes;
PolicyDetailsRentersAssurant.defaultProps = defaultProps;

export default PolicyDetailsRentersAssurant;
